import React, { useState } from 'react'
import { Calendar, ChevronDown } from 'lucide-react'

interface DateFilterOption {
  value: string
  label: string
}

const dateFilterOptions: DateFilterOption[] = [
  { value: '24h', label: 'Last 24 hours' },
  { value: '7d', label: 'Last 7 days' },
  { value: '1m', label: 'Last Month' },
  { value: '1y', label: 'Last Year' }
]

interface DateFilterPopoverProps {
  selectedValue: string
  onValueChange: (value: string) => void
}

export const DateFilterPopover: React.FC<DateFilterPopoverProps> = ({
  selectedValue,
  onValueChange
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const selectedOption = dateFilterOptions.find(option => option.value === selectedValue) || dateFilterOptions[0]

  const handleOptionClick = (value: string) => {
    onValueChange(value)
    setIsOpen(false)
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center px-4 py-3 bg-white text-gray-700 border border-gray-200 text-sm font-medium rounded-full hover:bg-gray-50 transition-colors"
      >
        <Calendar className="w-4 h-4 mr-2" />
        {selectedOption.label}
        <ChevronDown className="w-4 h-4 ml-2" />
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Popover */}
          <div className="absolute top-full left-0 mt-2 z-20 bg-white border border-gray-200 rounded-lg shadow-lg min-w-[160px]">
            <div className="py-1">
              {dateFilterOptions.map((option) => (
                <button
                  key={option.value}
                  onClick={() => handleOptionClick(option.value)}
                  className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 transition-colors ${
                    selectedValue === option.value 
                      ? 'bg-gray-100 font-semibold text-gray-900' 
                      : 'text-gray-700'
                  }`}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  )
}
